import { NewsletterConfirmation } from "types/Newsletter"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const confirmationReducer: RemoteReducer<NewsletterConfirmation[]> =
  createRemoteReducer("confirmation")
